import Avatar from '@material-ui/core/Avatar';
import Box from '@material-ui/core/Box';
import Chip from '@material-ui/core/Chip';
import { makeStyles } from '@material-ui/core/styles';
import FlipToBackOutlinedIcon from '@material-ui/icons/FlipToBackOutlined';
import FlipToFrontIcon from '@material-ui/icons/FlipToFront';
import MicOutlinedIcon from '@material-ui/icons/Mic';
import MicOffOutlinedIcon from '@material-ui/icons/MicOff';
import clsx from 'clsx';
import ClassMode from 'enums/ClassMode';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    paddingLeft: theme.spacing(3),
    paddingBottom: theme.spacing(1),
  },
  avatar: {
    marginLeft: theme.spacing(1),
    width: theme.spacing(3),
    height: theme.spacing(3),
  },
  chip: {
    backgroundColor: '#0000008A',
    height: theme.spacing(3),
    marginRight: theme.spacing(1),
    color: 'white',
  },
  blue: {
    color: '#fff',
    backgroundColor: theme.palette.primary.main,
  },
}));

RemoteControlOverlay.propTypes = {
  thisAttendeeId: PropTypes.string,
  isHost: PropTypes.bool,
  isSelected: PropTypes.bool,
  selectSpeaker: PropTypes.func,
};

export default function RemoteControlOverlay({ thisAttendeeId, isSelected, selectSpeaker }) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [user, setUser] = useState({});
  const { classMode, meetingId, isHost, name, hostId, roster } = useSelector(({ user, chime }) => ({
    classMode: user.classMode,
    meetingId: chime.meetingId,
    name: chime.name,
    isHost: chime.isHost,
    hostId: chime.hostId,
    roster: chime.roster,
  }));

  useEffect(() => {
    setUser(roster[thisAttendeeId]);
  }, [thisAttendeeId, roster]);

  const muteParticipant = async () => {
    if (!roster[thisAttendeeId]?.muted && (isHost || classMode === ClassMode.Teacher)) {
      dispatch(muteParticipant({ thisAttendeeId, meetingId, name }));
    }
  };

  const avatarMicStyle = clsx({
    [classes.blue]: !user?.muted,
    [classes.avatar]: true,
    [classes.unChecked]: user?.muted,
  });

  const avatarSelectStyle = clsx({
    [classes.blue]: true,
    [classes.avatar]: true,
  });

  return (
    <div className={classes.root}>
      {(isHost || classMode === ClassMode.Teacher) && thisAttendeeId !== hostId && (
        <Avatar className={avatarSelectStyle}>
          {isSelected ? (
            <FlipToBackOutlinedIcon
              data-testid="speaker-on-icon"
              fontSize="small"
              onClick={() => selectSpeaker(false, thisAttendeeId)}
            />
          ) : (
            <FlipToFrontIcon
              data-testid="speaker-off-icon"
              fontSize="small"
              onClick={() => selectSpeaker(true, thisAttendeeId)}
            />
          )}
        </Avatar>
      )}
      <Avatar className={avatarMicStyle}>
        {user?.muted ? (
          <MicOffOutlinedIcon data-testid="mic-off-icon" fontSize="small" />
        ) : (
          <MicOutlinedIcon onClick={muteParticipant} data-testid="mic-on-icon" fontSize="small" />
        )}
      </Avatar>
      <Box flexGrow={1} />
      <Chip className={classes.chip} label={user?.name} />
    </div>
  );
}
